import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { IStateTree } from "../../../../store/interfaces";
import { IUser, SolfaAudioType } from "../../../../store/user/models";

import loadableComponent from "./loadable";

const mapStateToProps = ({ user }: IStateTree) => ({
    reversedToneset: (user as IUser).reversedToneset || false,
    solfaAudio: (user as IUser).solfaAudio || SolfaAudioType.Solfa,
});

export default connect(mapStateToProps)(injectIntl(loadableComponent));
